import { ICON_TYPES } from '../constants';

export const GalleryIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M12 1.5C12 1.10218 11.842 0.720644 11.5607 0.43934C11.2794 0.158035 10.8978 0 10.5 0L5.5 0C5.10218 0 4.72064 0.158035 4.43934 0.43934C4.15804 0.720644 4 1.10218 4 1.5V2.5H3.5C3.10218 2.5 2.72064 2.65804 2.43934 2.93934C2.15804 3.22064 2 3.60218 2 4V5H1.5C1.10218 5 0.720644 5.15804 0.43934 5.43934C0.158035 5.72064 0 6.10218 0 6.5L0 12H8V9.5H10V7H12V1.5ZM1.5 6H6.5C6.63261 6 6.75979 6.05268 6.85355 6.14645C6.94732 6.24021 7 6.36739 7 6.5V6.793L5 8.793L4.0265 7.819L1 10.413V6.5C1 6.36739 1.05268 6.24021 1.14645 6.14645C1.24021 6.05268 1.36739 6 1.5 6ZM7 11H1.85L3.972 9.181L5 10.207L7 8.207V11ZM9 8.5H8V6.5C8 6.10218 7.84196 5.72064 7.56066 5.43934C7.27936 5.15804 6.89782 5 6.5 5H3V4C3 3.86739 3.05268 3.74021 3.14645 3.64645C3.24021 3.55268 3.36739 3.5 3.5 3.5H8.5C8.63261 3.5 8.75979 3.55268 8.85355 3.64645C8.94732 3.74021 9 3.86739 9 4V8.5ZM11 6H10V4C10 3.60218 9.84196 3.22064 9.56066 2.93934C9.27936 2.65804 8.89782 2.5 8.5 2.5H5V1.5C5 1.36739 5.05268 1.24021 5.14645 1.14645C5.24021 1.05268 5.36739 1 5.5 1H10.5C10.6326 1 10.7598 1.05268 10.8536 1.14645C10.9473 1.24021 11 1.36739 11 1.5V6ZM2 7.5C2 7.40111 2.02932 7.30444 2.08427 7.22221C2.13921 7.13999 2.2173 7.0759 2.30866 7.03806C2.40002 7.00022 2.50055 6.99031 2.59755 7.00961C2.69454 7.0289 2.78363 7.07652 2.85355 7.14645C2.92348 7.21637 2.9711 7.30546 2.99039 7.40245C3.00969 7.49945 2.99978 7.59998 2.96194 7.69134C2.9241 7.7827 2.86001 7.86079 2.77779 7.91573C2.69556 7.97068 2.59889 8 2.5 8C2.36739 8 2.24021 7.94732 2.14645 7.85355C2.05268 7.75979 2 7.63261 2 7.5Z"
          fill="#E35205"
        />
      </g>
    </svg>
  );
};

GalleryIcon.iconType = ICON_TYPES.GALLERY_ICON;
